/**
 * 🏗️ FSD Shared Layer - Activity Constants
 * 
 * ActivityPage에서 사용되는 Mock 데이터들
 */ import { Code, Layout, Award, Zap } from 'lucide-react';
/**
 * 활동 Mock 데이터
 */ export var MOCK_ACTIVITIES = [
    {
        id: 'act-001',
        type: 'activityTypes.learning',
        title: 'JavaScript 기초 과정 완료',
        description: '변수, 함수, 객체, 배열 등 JavaScript 기초 개념 학습',
        date: '2023-11-25',
        time: '14:30',
        duration: '1시간 20분',
        points: 50,
        completed: true,
        category: 'categories.programmingLanguage'
    },
    {
        id: 'act-002',
        type: 'activityTypes.problemSolving',
        title: '알고리즘 문제 #42 해결',
        description: '이진 트리 순회 알고리즘 문제 해결',
        date: '2023-11-24',
        time: '19:45',
        duration: '45분',
        points: 30,
        completed: true,
        category: 'categories.algorithm'
    },
    {
        id: 'act-003',
        type: 'activityTypes.project',
        title: '포트폴리오 웹사이트 작업',
        description: '메인 페이지 레이아웃 및 반응형 디자인 구현',
        date: '2023-11-23',
        time: '10:15',
        duration: '3시간 30분',
        points: 75,
        completed: false,
        category: 'categories.webDevelopment'
    },
    {
        id: 'act-004',
        type: 'activityTypes.challenge',
        title: '30일 코딩 챌린지 - 12일차',
        description: '문자열 조작 관련 코딩 문제 해결',
        date: '2023-11-22',
        time: '20:30',
        duration: '1시간',
        points: 40,
        completed: true,
        category: 'categories.algorithm'
    },
    {
        id: 'act-005',
        type: 'activityTypes.test',
        title: 'CSS 지식 테스트',
        description: 'CSS 레이아웃 및 선택자 관련 테스트',
        date: '2023-11-21',
        time: '15:00',
        duration: '25분',
        points: 35,
        completed: true,
        category: 'categories.webDevelopment'
    },
    {
        id: 'act-006',
        type: 'activityTypes.discussion',
        title: '프론트엔드 개발 그룹 토론 참여',
        description: 'React vs Vue 주제로 토론 참여',
        date: '2023-11-20',
        time: '18:00',
        duration: '1시간',
        points: 20,
        completed: true,
        category: 'categories.community'
    },
    {
        id: 'act-007',
        type: 'activityTypes.learning',
        title: 'React Hooks 학습',
        description: 'useEffect와 useContext 개념 및 활용법 학습',
        date: '2023-11-19',
        time: '11:30',
        duration: '2시간',
        points: 60,
        completed: true,
        category: 'categories.framework'
    }
];
/**
 * 스킬 Mock 데이터
 */ export var MOCK_SKILLS = [
    {
        name: 'skills.javascript',
        level: 4,
        progress: 80,
        category: 'skillCategories.language'
    },
    {
        name: 'skills.python',
        level: 3,
        progress: 60,
        category: 'skillCategories.language'
    },
    {
        name: 'skills.htmlCss',
        level: 4,
        progress: 85,
        category: 'skillCategories.language'
    },
    {
        name: 'skills.react',
        level: 3,
        progress: 65,
        category: 'skillCategories.framework'
    },
    {
        name: 'skills.nodejs',
        level: 2,
        progress: 40,
        category: 'skillCategories.framework'
    },
    {
        name: 'skills.git',
        level: 3,
        progress: 70,
        category: 'skillCategories.tool'
    },
    {
        name: 'skills.algorithm',
        level: 2,
        progress: 45,
        category: 'skillCategories.concept'
    },
    {
        name: 'skills.database',
        level: 2,
        progress: 35,
        category: 'skillCategories.concept'
    }
];
/**
 * 성취 Mock 데이터
 */ export var MOCK_ACHIEVEMENTS = [
    {
        id: 'ach-001',
        title: 'achievements.firstCode',
        date: '2023-09-01',
        icon: Code
    },
    {
        id: 'ach-002',
        title: 'achievements.tenDaysStreak',
        date: '2023-10-15',
        icon: Zap
    },
    {
        id: 'ach-003',
        title: 'achievements.algorithmMaster',
        date: '2023-11-05',
        icon: Award
    },
    {
        id: 'ach-004',
        title: 'achievements.projectComplete',
        date: '2023-11-20',
        icon: Layout
    }
];
/**
 * 통계 Mock 데이터
 */ export var MOCK_STATS = [
    {
        label: 'stats.totalStudyTime',
        value: '42시간 15분'
    },
    {
        label: 'stats.completedCourses',
        value: '5개'
    },
    {
        label: 'stats.consecutiveStudyDays',
        value: '12일'
    }
];
/**
 * AI 피드백 Mock 데이터
 */ export var MOCK_AI_FEEDBACKS = [
    // 전문 영역 피드백
    {
        id: 'fb-001',
        learningArea: 'feedbackAreas.algorithm',
        strengthScore: 85,
        improvementNeeded: false,
        feedbackText: '알고리즘 문제 해결 능력이 뛰어납니다. 특히 재귀와 동적 프로그래밍에 대한 이해도가 높습니다.',
        suggestedResources: [
            '고급 알고리즘 코스',
            '알고리즘 복잡도 분석 워크샵'
        ],
        date: '2023-11-25'
    },
    {
        id: 'fb-002',
        learningArea: 'feedbackAreas.frontend',
        strengthScore: 78,
        improvementNeeded: false,
        feedbackText: '프론트엔드 개발 실력이 탄탄합니다. React 컴포넌트 설계와 상태 관리에 능숙합니다.',
        suggestedResources: [
            '고급 React 패턴',
            'Next.js 심화 과정'
        ],
        date: '2023-11-24'
    },
    {
        id: 'fb-003',
        learningArea: 'feedbackAreas.backend',
        strengthScore: 65,
        improvementNeeded: true,
        feedbackText: '백엔드 기초는 갖추었으나 확장성과 성능 최적화 부분에서 개선이 필요합니다.',
        suggestedResources: [
            'Node.js 성능 최적화',
            '마이크로서비스 아키텍처'
        ],
        date: '2023-11-23'
    },
    {
        id: 'fb-004',
        learningArea: 'feedbackAreas.database',
        strengthScore: 60,
        improvementNeeded: true,
        feedbackText: 'SQL 기본 문법은 이해하고 있으나 쿼리 최적화와 인덱싱에 대한 학습이 필요합니다.',
        suggestedResources: [
            'DB 성능 튜닝',
            'NoSQL 기초'
        ],
        date: '2023-11-22'
    },
    // 코딩 기본기 피드백
    {
        id: 'fb-005',
        learningArea: 'feedbackAreas.dataStructure',
        strengthScore: 72,
        improvementNeeded: false,
        feedbackText: '기본 자료구조에 대한 이해도가 좋습니다. 배열, 리스트, 트리 구조를 잘 활용합니다.',
        suggestedResources: [
            '고급 자료구조',
            '그래프 알고리즘'
        ],
        date: '2023-11-21'
    },
    {
        id: 'fb-006',
        learningArea: 'feedbackAreas.codingStyle',
        strengthScore: 88,
        improvementNeeded: false,
        feedbackText: '코드 가독성과 일관성이 매우 뛰어납니다. 명명 규칙과 주석 작성이 우수합니다.',
        suggestedResources: [
            '클린 코드 마스터',
            '코드 리뷰 베스트 프랙티스'
        ],
        date: '2023-11-20'
    },
    {
        id: 'fb-007',
        learningArea: 'feedbackAreas.debugging',
        strengthScore: 58,
        improvementNeeded: true,
        feedbackText: '기본적인 디버깅은 가능하나 복잡한 문제 해결 시 체계적인 접근이 부족합니다.',
        suggestedResources: [
            '고급 디버깅 기법',
            '에러 추적 및 로깅'
        ],
        date: '2023-11-19'
    },
    {
        id: 'fb-008',
        learningArea: 'feedbackAreas.versionControl',
        strengthScore: 75,
        improvementNeeded: false,
        feedbackText: 'Git 기본 명령어를 잘 활용하고 브랜치 전략에 대한 이해도가 좋습니다.',
        suggestedResources: [
            'Git 고급 기능',
            '협업 워크플로우'
        ],
        date: '2023-11-18'
    }
];
